export const B2bProductPriceRange = ({ storeInfo, price_range }) => {
  return (
    <article className="details__box--price">
      <div className="details__box--price-container" rel="schema:offers">
        <div property="schema:priceCurrency" content="INR"></div>
        <span
          className="details__box--price-value details__box--price-discounted"
          style={{
            color: storeInfo?.theme?.colors?.primary_color,
          }}
        >
          <span property="price">{price_range || 'Pricing on Request'}</span>
        </span>
      </div>
    </article>
  );
};
